import {
  DateRangeDropdownV2,
  DocumentNumberRangeFieldV2 as DocumentNumberRange,
  FormField
} from '@/components/custom/erp';

import { Label } from '@/components/ui/label';

const BasicInfoTab = () => {
  return (
    <div className='space-y-2 p-4'>
      <div className='flex flex-col space-y-3'>
        {/* Date Range Fields */}
        <div className='flex w-[61%] items-center'>
          <Label className='w-40 min-w-40'>Ngày nhập từ/đến</Label>
          <DateRangeDropdownV2
            fromDateName='ngay_ct1'
            toDateName='ngay_ct2'
            toFieldClassName='w-40'
            fromFieldClassName='w-40'
          />
        </div>

        {/* Số chứng từ từ/đến */}
        <div className='flex items-center'>
          <DocumentNumberRange fromName='so_ct1' toName='so_ct2' labelClassName='w-40' />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
